export const initialState = {
    is_loading_users: true,
    users: [],
    users_type: "CUSTOMER",
    users_list_search_text: "",
    selected_user: null,
    is_get_archive_user: false
}